// extracted by mini-css-extract-plugin
export default {"box":"courseSummary-module--box--3wKAw"};